import { Pipe, PipeTransform } from '@angular/core';
import { tiposBolsa } from '../components/api/models/allEnums';

@Pipe({
  name: 'tiposBolsa'
})
export class TiposBolsaPipe implements PipeTransform {

  transform(value: tiposBolsa | string | undefined): string {
    if (value === undefined || value === null) {
      return 'Desconhecido';
    }
    return TiposBolsaDescriptions[value as tiposBolsa] || 'Desconhecido';
  }

}

export const TiposBolsaDescriptions: { [key in tiposBolsa]: string } = {
  [tiposBolsa.Interna]: "Interna",
  [tiposBolsa.Externa]: "Externa",
};
